
import React, { useEffect, useState } from 'react';
import { meetingSDK } from "unifiedring-sdk";
import { DatePicker, Menu, Select } from 'antd';
// import iconincoming from "../../../styles/images/iconincoming.svg";
// import iconoutgoing from "../../../styles/images/iconoutgoing.svg";
import { Dropdown, Switch, Modal, Input } from "antd";
//import TextArea from "antd/lib/input/TextArea";
//import users from "../../../../styles/images/1a.png";
import moment from 'moment';
import { URRadio } from '../../../../shared/widgets/radiobox';
import { URInput } from "../../../../shared/widgets/input";
import { URButton } from "../../../../shared/widgets/button";
import { TIMEZONE } from '../../../../base/meetingService/timezone';
import _, { isArray } from "lodash";
import { storeMeetingPage, storeWindowState } from "../../../../base/meetingService/meetingStoreServices";
import { calendarType,generatePassword} from '../../../../base/meetingService/utils/meetingServices';
import { URCheckBox } from "../../../../shared/widgets/checkBoxForCall";
import { RRule} from 'rrule';
import { getEndDate, rRuleFrame } from "../../../../base/meetingService/rrule";
import { asrSearchLanguage, getHourFormat, getMaxDurationFormat, getTimeFormatAMPM, searchHandler, searchHighlight, toastInformation, userStatusColor, getCurrentTime  } from "../../../../base/callService/common";
import store from "../../../../context/store/store";
import { useSelector } from "react-redux";
import FileUpload_MeetingCreation from "../meetingSchedule/fileUpload";
import styles from './editMeeting.module.scss';
import { editMeetingApi, getMeetingLists, updateMeetingRead } from '../../../../base/meetingService/apiService';
import { meetingDetails } from '../../../../models/meetingModel';
import SingleParticipantList from '../singleParticipantList';

import taskimg2 from "../../../../styles/images/task2.svg";
import { URAvatarGroup } from '../../../../shared/widgets/avatarGroup';
import { URStatusDot } from '../../../../shared/widgets/avatarGroup/statusDot';
import { useHistory } from 'react-router-dom';
import { Types } from '../../../../context/action/action';

type MeetingRescheduleState = {
  alternateHost: any;
  isMoreDetail: boolean;
  meetingDetail: meetingDetails;
  existingParticipant:any;
  timeZoneValue: any;
  showEndhours: string;
  personalMeetingId: string;
  isRecurring: boolean;
  is_speaking_lang: boolean;
  rruleOption: any;
  s_Date_Calender: Date;
  e_Date_Calender: any;
  rruleText:any;
  max_duration: any;
  max_Time: any;
  spech_Search: string;
  ast_default_Spe_Opt: string;
  isSpeakView: boolean;
  endAt: string;
  isCancelMeetingModalVisible: boolean;
  alternateHostDetails: any;
  participantSipDetails: any;
  buttonEnableStatus: boolean;
  allContacts:any;
  contacts:any;
  searchKey:any;
  openParticipant: boolean;
  alternateSipid: any;
  favContactList: any;
};

const { Option } = Select;

export default function EditMeeting() {
  let { meetingReducer , loginReducer, contactReducer}: any = useSelector((state: any) => state);
  let { detailPage, currentWindowState, getListInput,planBased } = meetingReducer;
  let {userdetails} = loginReducer;
  let { workContacts,favContacts } = contactReducer;
 let allday: any = Array.from(Array(25).keys());
  let timeDurationList: any = Array.from(Array(12).keys());
    var interval = 30 * 60 * 1000;
    let start_time:any=new Date(Math.ceil(new Date().getTime() / interval) * interval)
  var travelTime = currentWindowState !== 'editMeeting' ?
  (moment(start_time.getTime()).add(1, 'hours').format('hh:mm A')).split(" "):
    (moment(detailPage.start_timestamp).format('hh:mm A')).split(" ");
  let alternateHost = _.find(detailPage.participants, function(o) {
    return o.roletype === 2;
  });
 let favList: Array<any> = _.filter(favContacts,((contacts:any)=>{
    return !Object.keys(contacts).some(key => key === 'team_id_prefix');
    })); 
  var newCurrentDate = new Date();
  let history = useHistory();
  const [recurrenceMeetingBtn, setRecurrenceMeetingBtn] = useState(false)
  const [alternateHostBtn, setAlternateHostBtn] = useState(false)
  // const setHours = (dt: Date, h: string) => {
  //   var s: any = /(\d+):(\d+)(.+)/.exec(h);
  //   dt.setHours(s[3] === "pm" ?
  //     12 + parseInt(s[1], 10) :
  //     parseInt(s[1], 10));
  //   dt.setMinutes(parseInt(s[2], 10));
  // };


  let objectList:any = []
  if(detailPage.participants && isArray(detailPage.participants) && detailPage.participants.length > 0){
     objectList = detailPage.participants.reduce((acc: any, curr: any) => {
      if (curr?.name) {
        return (acc[curr["sipid"]] = curr, acc);
      }
    }, {});
  }

  const updateMeetingDetail = (key: any, status?: any) => {
setData({ ...getData, meetingDetail: { ...getData.meetingDetail, [key]: status } })
    // if(key === "is_participant_join_bef_host")
    // {
    //   setData({ ...getData, meetingDetail: { ...getData.meetingDetail,is_participant_waiting_room:status ? false:true,[key] :status } })
    // }
    // else if (key === "is_participant_waiting_room")
    // {
    //   setData({ ...getData, meetingDetail: { ...getData.meetingDetail, is_participant_join_bef_host: status ? false : true,[key] :status } })
    // }
      if (key === "is_alternate_host")
    {
      if(!status){
        setData({ ...getData, meetingDetail: { ...getData.meetingDetail, is_participant_join_bef_host: status ? false : true,[key] :status,alternate_host:{} } })
      }
      else{ setData({ ...getData, meetingDetail: { ...getData.meetingDetail, is_participant_join_bef_host: status ? false : true,[key] :status } })}
    }
    else {
      console.log("need to handle");
    }
  };

  const updateStatus = (key:any,value:any) => {
    setData({ ...getData, [key]: value });
  };

  const [timepickEdit, setTimepickEdit] = useState(false);
  const getEndstring = (startDate: Date, hrMin: string, isAmPm: string, duratin: any) => {
 let newDate: Date = new Date(startDate);
    let splitHrMin = hrMin.split(":");
    let timeFormat: any=getTimeFormatAMPM(splitHrMin,isAmPm);
    newDate.setHours(timeFormat);
    newDate.setMinutes(parseInt(splitHrMin[1]));
    let splitDuration: any = duratin?.toString()?.split(":");
    let endDate: any = newDate.setHours(newDate.getHours() + parseInt(splitDuration[0]), newDate.getMinutes() + parseInt(splitDuration[1]));
    if (moment(moment().format('yyyy-MM-DD')).isSame(moment(endDate).format('yyyy-MM-DD'))) { return 'The meeting will end at ' + moment(endDate).format('hh:mm a') }
    else {
      return 'The meeting will  end on '
        + moment(endDate).format('yyyy-MM-DD').toLowerCase() + ' at ' + moment(endDate).format('hh:mm a');
    }
  };

  var hours = Math.floor(detailPage.duration_minutes / 60);
  var minutes = detailPage.duration_minutes % 60;

  let arrayList: any = []
  if(detailPage.participants && isArray(detailPage.participants) && detailPage.participants.length > 0){
    detailPage?.participants.map((contacts: any, index: any) => {
      if ((contacts.sipid !== userdetails.sip_login_id && contacts.sipid !== alternateHost?.sipid))
        arrayList.push(parseInt(contacts.sipid));
    })
  }


  const [getData, setData] = useState<MeetingRescheduleState>({
    isMoreDetail: false,
    participantSipDetails:arrayList || [],
    alternateHostDetails:[],
    alternateHost:[],
    meetingDetail: {
      status: (currentWindowState === 'useTemplate' || currentWindowState==='reschedule')  ? "Start" : detailPage.status,
      title: detailPage.title || "",
      description: detailPage.description || "",
      dial_in_countries: detailPage.dial_in_countries || [],
      start_timestamp: currentWindowState !== 'editMeeting' ? start_time.getTime:detailPage.start_timestamp,
      end_timestamp: currentWindowState !== 'editMeeting'?  new Date():detailPage.end_timestamp,
      is_alternate_host: detailPage.is_alternate_host || false,
      time: currentWindowState !== 'editMeeting'?{ hours: '1', minutes: "00" }:{ hours: hours, minutes: minutes },
      isAmPM: (travelTime[1]),
      restrictScreenShare: detailPage.restrictScreenShare ,
      duration:currentWindowState !== 'editMeeting'?{ hours: '1', minutes: "00" }: { hours: hours, minutes: minutes },
      duration_minutes: currentWindowState !== 'editMeeting'? 60:detailPage.duration_minutes,
      participants: detailPage.participants || [],
      timezone: detailPage.timezone || "",
      calender_type: detailPage.calender_type || "",
      is_host_myvideo: detailPage.is_host_myvideo,
      is_host_myaudio: detailPage.is_host_myaudio,
      is_participant_video: detailPage.is_participant_video,
      is_participant_waiting_room: detailPage.is_participant_waiting_room,
      is_record_meeting: detailPage.is_record_meeting,
      requireAuthentication:detailPage.requireAuthentication,
      authenticationJoin:detailPage.authenticationJoin,
      is_participant_join_bef_host: detailPage.is_participant_join_bef_host,
      is_participant_invite_guest: detailPage.is_participant_invite_guest,
      is_participant_mute_entry: detailPage.is_participant_mute_entry,
      alternate_host:alternateHost ? alternateHost : [],
      is_use_personal_meeting_id: detailPage.is_use_personal_meeting_id,
      personal_meeting_id: detailPage.personal_meeting_id,
      recurrenceId: detailPage.rrule !== "" ?  detailPage.recurrenceId : "",
      current_timestamp: detailPage.start_timestamp,
      meeting_id: detailPage.meeting_id,
      is_custom_password: detailPage.is_custom_password,
      password: detailPage.password ? detailPage.password : generatePassword(),
      recurrence: detailPage?.rrule?.includes("FREQ=DAILY")
                ? "Daily" : detailPage?.rrule?.includes("FREQ=WEEKLY")
                  ? "Weekly" : detailPage?.rrule?.includes("FREQ=MONTHLY")
                    ? "Monthly": "None",
      rrule: detailPage.rrule,
      save_template: detailPage.save_template,
      joining_option_type: detailPage.joining_option_type,
      is_without_host_continue: detailPage.is_without_host_continue || true,
      speakingLanguage: detailPage.speakingLanguage,
      files: detailPage.files
    },
    timeZoneValue: TIMEZONE,
    showEndhours: '',
    existingParticipant:objectList,
    personalMeetingId: detailPage.personalMeetingId,
    isRecurring: detailPage.rrule==="" ? false: true,
    is_speaking_lang: detailPage.speakingLanguage ? true: false,
    rruleOption: {
      isRecurringEvent: false,
      repeat_every: 1,
      value_disabled: true,
      afteroccur: 7,
      occurOnDay: newCurrentDate.getDate(),
      monthlyOccureon: true,
      monthlyWeek: "First",
      monthlyDay: "Sun",
      weeklyOccuron: []
    },
    s_Date_Calender: currentWindowState !== 'editMeeting' ?start_time:new Date(detailPage.start_timestamp),
    e_Date_Calender: currentWindowState !== 'editMeeting' ?new Date():new Date(detailPage.end_timestamp),
    max_duration: getHourFormat(detailPage.duration_minutes)?.toString(),
    max_Time: travelTime[0],
    spech_Search: '',
    rruleText:'',
    ast_default_Spe_Opt: detailPage.speakingLanguage?.includes("en") ? "Global English (en)" : detailPage.speakingLanguage?.includes("pt") ? "Portuguese (pt)": detailPage.speakingLanguage?.includes("es") ? "Spanish (es)" : detailPage.speakingLanguage?.includes("fr") ? "French (fr)" : detailPage.speakingLanguage?.includes("ja") ?  "Japanese (ja)" : "Korean (ko)",
    isSpeakView: false,
    endAt:currentWindowState !== 'editMeeting'  ? getEndstring(new Date(), travelTime[0], travelTime[1], getHourFormat(detailPage.duration_minutes)?.toString())
      :getEndstring(new Date(detailPage.start_timestamp), travelTime[0], travelTime[1], getHourFormat(detailPage.duration_minutes)?.toString()),
    isCancelMeetingModalVisible: false,
    buttonEnableStatus:false,
    allContacts:workContacts,
    contacts:workContacts,
    searchKey:"",
    openParticipant: arrayList?.length > 0 ? true : false,
    alternateSipid:alternateHost ? [parseInt(alternateHost?.sipid)] : [],
    favContactList:[]
  });

  useEffect(() => {
   
    // {Edit Meeting Recurrence}
    const RecurrenceMeeting = planBased.find((item:any) => item.featureid === 3);
    if (RecurrenceMeeting && RecurrenceMeeting.value1 === "Yes") {
      setRecurrenceMeetingBtn(false); 
    } else {
      setRecurrenceMeetingBtn(true);
    }

    // {Edit Meeting AlternateHost}
    const AlternateHost = planBased.find((item:any) => item.featureid === 20);
    if (AlternateHost && AlternateHost.value1 === "No") {
      setAlternateHostBtn(false); 
    } else {
      setAlternateHostBtn(true);
    }
    
  }, [planBased]); 


useEffect(()=>{
  let editRRule:any;
  if(detailPage.rrule && !detailPage?.rrule?.includes('every') && detailPage.rrule.includes('UNTIL') ){
     editRRule= new RRule(RRule.parseString(detailPage.rrule));



   //let parseString = RRule.parseText('every day for 3 times')

    const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    let bynweekday = editRRule?.options?.bynweekday || [];
    var end_date = new Date(parseFloat(detailPage.end_timestamp));
    let monthlyweekNo = bynweekday?.length > 0 ?bynweekday[0][1] === -1 ?'First':bynweekday[0][1] === -2?'Second':
      bynweekday[0][1] === -3?'Third':bynweekday[0][1] === -4?'Fourth':'Last' : 'First';
    let bynmonthlyDay = bynweekday?.length > 0 ?days[bynweekday[0][0]]:'Sun';
    let recurrence = editRRule?.options?.freq === 1 ? 'Monthly' : editRRule?.options?.freq === 2 ? 'Weekly' : editRRule?.options?.freq === 3 ? 'Daily' : 'None';
    
    let tempDays:any = [];
    let byweekday:any = editRRule?.options?.byweekday || [];
    byweekday.map((item: any) => {
      tempDays.push(days[item]);
    });


    
    setData({
      ...getData, participantSipDetails: arrayList, rruleOption: { ...getData.rruleOption, monthlyWeek: monthlyweekNo, repeat_every:editRRule?.options?.interval,weeklyOccuron:tempDays, monthlyDay: bynmonthlyDay}, meetingDetail: { ...getData.meetingDetail, recurrence: recurrence }, e_Date_Calender: end_date, isRecurring:true
    });

  }
  else{
    editRRule ={};
  }
  history.push("/meeting");
  return (() => {
   setData({...getData,buttonEnableStatus:false})
 })

}, [])
  
  useEffect(() => {
 
    let timeset: any = document.getElementById("appt");
    let time = getCurrentTime();
    console.log("timetime", time)
    if (timeset) {
      timeset.value = getCurrentTime();
    }
    if (alternateHost) {

      console.log("alternateHost?.sipid >>>>>>>", alternateHost?.sipid);
      let filterdList = _.filter(workContacts, function (o: any) {
        return o.sip_login_id !== parseInt(alternateHost?.sipid);
      });
      let filtered_favs=_.filter(favList, function (o: any) {
        return o.sip_login_id !== parseInt(alternateHost?.sipid);
      });
      
      setData({
        ...getData, participantSipDetails: arrayList || [],
        alternateSipid: alternateHost ? [parseInt(alternateHost?.sipid)] : [],
        openParticipant: arrayList?.length > 0 ? true : false,
        meetingDetail: {
          status: (currentWindowState === 'useTemplate' || currentWindowState === 'reschedule') ? "Start" : detailPage.status,
          title: detailPage.title || "",
          description: detailPage.description || "",
          dial_in_countries: detailPage.dial_in_countries || [],
          start_timestamp: currentWindowState !== 'editMeeting' ? start_time : detailPage.start_timestamp,
          end_timestamp: currentWindowState !== 'editMeeting' ? new Date() : detailPage.end_timestamp,
          is_alternate_host: alternateHost ? true : false,
          time: currentWindowState !== 'editMeeting' ? { hours: '1', minutes: "00" } : { hours: hours, minutes: minutes },
          isAmPM: (travelTime[1]),
          duration: currentWindowState !== 'editMeeting' ? { hours: '1', minutes: "00" } : { hours: hours, minutes: minutes },
          duration_minutes: currentWindowState !== 'editMeeting' ? 60 : detailPage.duration_minutes,
          participants: detailPage.participants || [],
          timezone: detailPage.timezone,
          calender_type: detailPage.calender_type || "",
          is_host_myvideo: detailPage.is_host_myvideo,
          is_host_myaudio: detailPage.is_host_myaudio,
          is_participant_video: detailPage.is_participant_video,
          is_participant_waiting_room: detailPage.is_participant_waiting_room,
          is_record_meeting: detailPage.is_record_meeting,
          requireAuthentication:detailPage.requireAuthentication,
      authenticationJoin:detailPage.authenticationJoin,
          is_participant_join_bef_host: detailPage.is_participant_join_bef_host,
          is_participant_invite_guest: detailPage.is_participant_invite_guest,
          is_participant_mute_entry: detailPage.is_participant_mute_entry,
          alternate_host: alternateHost ? alternateHost : [],
          is_use_personal_meeting_id: detailPage.is_use_personal_meeting_id,
          personal_meeting_id: detailPage.personal_meeting_id,
           recurrenceId: detailPage.rrule !== "" ?  detailPage.recurrenceId : "",
      current_timestamp: detailPage.start_timestamp,
          meeting_id: detailPage.meeting_id || "",
          is_custom_password: detailPage.is_custom_password,
          password: detailPage.password ? detailPage.password : generatePassword(),
          recurrence: detailPage?.rrule?.includes("FREQ=DAILY")
            ? "Daily" : detailPage?.rrule?.includes("FREQ=WEEKLY")
              ? "Weekly" : detailPage?.rrule?.includes("FREQ=MONTHLY")
                ? "Monthly" : "None",
          rrule: detailPage.rrule,
          save_template: detailPage.save_template || false,
          joining_option_type: detailPage.joining_option_type,
          is_without_host_continue: detailPage.is_without_host_continue || true,
          speakingLanguage: detailPage.speakingLanguage,
          files: detailPage.files || []
        },

        timeZoneValue: TIMEZONE,
        showEndhours: '',
        existingParticipant: objectList,
        personalMeetingId: detailPage.personalMeetingId,
        isRecurring: detailPage.rrule === "" ? false : true,
        is_speaking_lang: detailPage.speakingLanguage ? true: false,
        rruleOption: {
          isRecurringEvent: false,
          repeat_every: 1,
          value_disabled: true,
          afteroccur: 7,
          occurOnDay: newCurrentDate.getDate(),
          monthlyOccureon: true,
          monthlyWeek: "First",
          monthlyDay: "Sun",
          weeklyOccuron: []
        },
        s_Date_Calender: currentWindowState !== 'editMeeting' ?start_time : new Date(detailPage.start_timestamp),
        e_Date_Calender: currentWindowState !== 'editMeeting' ? new Date() : new Date(detailPage.end_timestamp),
        max_duration: getHourFormat(detailPage.duration_minutes)?.toString(),
        max_Time: travelTime[0],
        spech_Search: '',
        rruleText: '',
        ast_default_Spe_Opt: detailPage.speakingLanguage?.includes("en") ? "Global English (en)" : detailPage.speakingLanguage?.includes("pt") ? "Portuguese (pt)": detailPage.speakingLanguage?.includes("es") ? "Spanish (es)" : detailPage.speakingLanguage?.includes("fr") ? "French (fr)" : detailPage.speakingLanguage?.includes("ja") ?  "Japanese (ja)" : "Korean (ko)",
        isSpeakView: false,
        endAt: currentWindowState !== 'editMeeting' ? getEndstring(new Date(), travelTime[0], travelTime[1], getHourFormat(detailPage.duration_minutes)?.toString())
          : getEndstring(new Date(detailPage.start_timestamp), travelTime[0], travelTime[1], getHourFormat(detailPage.duration_minutes)?.toString()),
        isCancelMeetingModalVisible: false,
        alternateHostDetails: alternateHost ? alternateHost.sipid : [],
        allContacts: filterdList,
        contacts:filterdList,
        favContactList:filtered_favs,
        restrictScreenShare:detailPage.restrictScreenShare

      })
    } else { 
    setData({
      ...getData,
      participantSipDetails: arrayList || [],
      openParticipant: arrayList?.length > 0 ? true : false,
      alternateSipid: alternateHost ? [parseInt(alternateHost?.sipid)] : [],
      meetingDetail: {
      status: (currentWindowState === 'useTemplate' || currentWindowState==='reschedule')? "Start" : detailPage.status,
      title: detailPage.title || "",
      description: detailPage.description || "",
      dial_in_countries: detailPage.dial_in_countries || [],
      start_timestamp: currentWindowState !== 'editMeeting'?start_time:detailPage.start_timestamp,
      end_timestamp: currentWindowState!== 'editMeeting'?  new Date():detailPage.end_timestamp,
      is_alternate_host: alternateHost ? true : false,
      time: currentWindowState!== 'editMeeting'?{ hours: '1', minutes: "00" }:{ hours: hours, minutes: minutes },
      isAmPM: (travelTime[1]),
      duration:currentWindowState !== 'editMeeting'?{ hours: '1', minutes: "00" }: { hours: hours, minutes: minutes },
      duration_minutes: currentWindowState !== 'editMeeting'? 60:detailPage.duration_minutes,
      participants: detailPage.participants || [],
      timezone: detailPage.timezone,
      calender_type: detailPage.calender_type || "",
      is_host_myvideo: detailPage.is_host_myvideo,
      is_host_myaudio: detailPage.is_host_myaudio,
      is_participant_video: detailPage.is_participant_video,
      is_participant_waiting_room: detailPage.is_participant_waiting_room,
      is_record_meeting: detailPage.is_record_meeting,
      is_participant_join_bef_host: detailPage.is_participant_join_bef_host,
      is_participant_invite_guest: detailPage.is_participant_invite_guest,
      is_participant_mute_entry: detailPage.is_participant_mute_entry,
      alternate_host: alternateHost ? alternateHost : [],
      is_use_personal_meeting_id: detailPage.is_use_personal_meeting_id,
      requireAuthentication:detailPage.requireAuthentication,
      authenticationJoin:detailPage.authenticationJoin,
        personal_meeting_id: detailPage.personal_meeting_id,
       recurrenceId: detailPage.rrule !== "" ?  detailPage.recurrenceId : "",
      current_timestamp: detailPage.start_timestamp,
      meeting_id: detailPage.meeting_id || "",
      is_custom_password: detailPage.is_custom_password,
      password: detailPage.password ? detailPage.password : generatePassword(),
      recurrence: detailPage?.rrule?.includes("FREQ=DAILY")
      ? "Daily" : detailPage?.rrule?.includes("FREQ=WEEKLY")
        ? "Weekly" : detailPage?.rrule?.includes("FREQ=MONTHLY")
          ? "Monthly": "None",
      rrule: detailPage.rrule,
      save_template: detailPage.save_template || false,
      joining_option_type: detailPage.joining_option_type,
      is_without_host_continue: detailPage.is_without_host_continue || true,
      speakingLanguage: detailPage.speakingLanguage,
      files: detailPage.files || []
    },
      
    timeZoneValue: TIMEZONE,
    showEndhours: '',
    existingParticipant:objectList,
    personalMeetingId: detailPage.personalMeetingId,
    isRecurring: detailPage.rrule==="" ? false: true,
    is_speaking_lang: detailPage.speakingLanguage ? true: false,
    rruleOption: {
      isRecurringEvent: false,
      repeat_every: 1,
      value_disabled: true,
      afteroccur: 7,
      occurOnDay: newCurrentDate.getDate(),
      monthlyOccureon: true,
      monthlyWeek: "First",
      monthlyDay: "Sun",
      weeklyOccuron: []
    },
    s_Date_Calender: currentWindowState !== 'editMeeting' ?start_time:new Date(detailPage.start_timestamp),
    e_Date_Calender: currentWindowState !== 'editMeeting' ?new Date():new Date(detailPage.end_timestamp),
    max_duration: getHourFormat(detailPage.duration_minutes)?.toString(),
    max_Time: travelTime[0],
    spech_Search: '',
    rruleText:'',
      ast_default_Spe_Opt: detailPage.speakingLanguage?.includes("en") ? "Global English (en)" : detailPage.speakingLanguage?.includes("pt") ? "Portuguese (pt)": detailPage.speakingLanguage?.includes("es") ? "Spanish (es)" : detailPage.speakingLanguage?.includes("fr") ? "French (fr)" : detailPage.speakingLanguage?.includes("ja") ?  "Japanese (ja)" : "Korean (ko)",
    isSpeakView: false,
    endAt:currentWindowState !== 'editMeeting' ?getEndstring(new Date(), travelTime[0], travelTime[1], getHourFormat(detailPage.duration_minutes).toString())
      :getEndstring(new Date(detailPage.start_timestamp), travelTime[0], travelTime[1],getHourFormat(detailPage.duration_minutes)?.toString()),
      isCancelMeetingModalVisible: false,
    alternateHostDetails:alternateHost ? alternateHost.sipid : [],
  restrictScreenShare:detailPage.restrictScreenShare
  
    })
}


  }, [detailPage.uuid])

  let resContact: any = searchHandler(workContacts, getData.searchKey);
  let len = Math.round((resContact?.length / 8));
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
  let editRRule:any = {}
  if(detailPage.rrule && !detailPage?.rrule?.includes('FREQ=FORTNIGHTLY') && detailPage.rrule.includes('UNTIL')){
   editRRule = new RRule(RRule.parseString(detailPage?.rrule));
  }
  else{
    editRRule={};
  }
  const fileOnchange = (files: any) => {
    setData({ ...getData, meetingDetail: { ...getData.meetingDetail, files: files } });
  };

  const alternativeHost = (value: any, obj: any) => {
    try {
    
      console.log("obj >>>>>>>>", obj);
      console.log("value >>>>>>>>", value);

     
    if (!_.isEmpty(value)) {
      let data = JSON.parse(obj[0].key);
      let HostDetail = {
        email: data.email_id,
        ext: data.ext,
        name: data.caller_id,
        profile_img: data.ImageURL,
        roletype: 2,
        sipid: data.sip_login_id,
        user_type: "company"
      };
 getData.meetingDetail.participants.push(HostDetail);
       let filterdList = _.filter(getData.contacts, function (o: any) {
         return o.sip_login_id !== parseInt(data?.sip_login_id);
      });
      setData({
        ...getData,alternateHostDetails:getData.alternateHostDetails,allContacts: filterdList,
        meetingDetail: { ...getData.meetingDetail, alternate_host: HostDetail }, alternateSipid:value
      });
    }
    else {
let findAltHostIdx:any=_.findIndex(getData.meetingDetail.participants, ((elem: any) => { return elem.roletype === 2 }));
if(findAltHostIdx > -1){
  getData.meetingDetail.participants.splice(findAltHostIdx,1);
      }
       setData({
        ...getData,alternateHostDetails:"",
        meetingDetail: { ...getData.meetingDetail,is_alternate_host:false, alternate_host: {} }, alternateSipid:[], allContacts:workContacts
      });
    }
  } catch (error) {
    console.log("error");
  }
    
  };


  const moreOptionTrigger = () => {
    setData({ ...getData, isMoreDetail: !getData.isMoreDetail });
  };

  const setSelectTime=(key:any,e:any)=>{
    setTimepickEdit(false);
   let endtAt: string = '';
if (getData.meetingDetail.recurrence === "None" && !getData.isRecurring) {
  endtAt = getEndstring(getData.s_Date_Calender, e.key, getData.meetingDetail.isAmPM,
    getData.max_duration);
}
setData({ ...getData, [key]: e.key, endAt: endtAt });
  }


  const disabledEndDate = (from: any, current: any) => {
      let customDate = moment().format("YYYY-MM-DD");

    //let firstDay =  moment().add(-1,'days').format("YYYY-MM-DD");
    let fiftyDay = moment().add(50,'days').format("YYYY-MM-DD");
   
     return current < moment(customDate, "YYYY-MM-DD")|| moment(fiftyDay, "YYYY-MM-DD")<= current
  };

  const videoShowHideStatus = (key: string, value: any) => {
    setData({ ...getData, meetingDetail: { ...getData.meetingDetail, [key]: value } });
  };

  const updateMultiCheckbox = (value: any) => {
    let { weeklyOccuron } = getData.rruleOption;
    let index = (weeklyOccuron).indexOf(value);
    if (index !== -1) { weeklyOccuron.splice(index, 1); }
    else { weeklyOccuron.push(value); }
    getData.rruleOption['weeklyOccuron'] = weeklyOccuron;
    let ruleIs = rRuleFrame(getData.rruleOption, getData.meetingDetail.recurrence,
      getData.s_Date_Calender,
      getData.e_Date_Calender);

    setData({
      ...getData, rruleOption: { ...getData.rruleOption, weeklyOccuron: weeklyOccuron },
      meetingDetail: { ...getData.meetingDetail, rrule: ruleIs.toString() }, rruleText:ruleIs.toText()
    });
  };

  const dateTimeSelectOpt = (value: any) => {
    if (getData.meetingDetail.recurrence !== "None" && getData.rruleOption.value_disabled) {
      let endDate = getEndDate(getData.meetingDetail.recurrence, getData.rruleOption.repeat_every, value);
      getData['e_Date_Calender'] = endDate;
      getData['s_Date_Calender'] = value;
      if(value){let ruleIs = rRuleFrame(getData.rruleOption, getData.meetingDetail.recurrence, value, endDate);
      setData({
        ...getData, meetingDetail: {
          ...getData.meetingDetail, rrule: ruleIs.toString()
        }, s_Date_Calender: value, e_Date_Calender: endDate, rruleText:ruleIs.toText()
      });}
    }
    else {
      let endtAt = getEndstring(new Date(value), getData.max_Time, getData.meetingDetail.isAmPM,
        getData.max_duration);
      //setData({ ...getData, meetingDetail: { ...getData.meetingDetail, [key]: value }, endAt: endtAt });
      setData({ ...getData, s_Date_Calender: value, endAt: endtAt });
    }
  };

  const timeZoneOnchange = (value: any) => {

    setData({ ...getData, meetingDetail: { ...getData.meetingDetail, timezone: value } });
  };

  const am_TO_pm_Onchange = (value: any) => {
    let endtAt = '';
    if (getData.meetingDetail.recurrence === "None" && !getData.isRecurring) {
      endtAt = getEndstring(getData.s_Date_Calender, getData.max_Time, value,
        getData.max_duration);
    }
    setData({ ...getData, meetingDetail: { ...getData.meetingDetail, isAmPM: value }, endAt: endtAt });
  };

  const defaultValueOnchange = (key: string, value: any) => {
    let endtAt: string = '';
    if (getData.meetingDetail.recurrence === "None" && !getData.isRecurring) {
      if (key === 'max_Time') {
        endtAt = getEndstring(getData.s_Date_Calender, value, getData.meetingDetail.isAmPM,
          getData.max_duration);
      }
      else {
        endtAt = getEndstring(getData.s_Date_Calender, getData.max_Time, getData.meetingDetail.isAmPM, value);
      }
    }
    setData({ ...getData, [key]: value, endAt: endtAt });

  };

  const handletimeedit = (value :any) =>{
    setTimepickEdit(value);
  }
 
  let timePickerNewList: any =['1','2','3','4','5','6','7','8','9','10','11','12'];  
  const timePickerNew = (
    <Menu className={`${"scroller"} timepic ${styles.timeSelect}`} onClick={(e:any)=>setSelectTime("max_Time",e)}>
       { timePickerNewList.map((value: string, index: number) => {
    return (
        <>
          <Menu.Item 
           key={`${value.toString().length === 1 ? '0'+value : value}:00`}>{`${value.toString().length === 1 ? '0'+value : value}:00`}</Menu.Item>
          <Menu.Item key={`${value.toString().length === 1 ? '0'+value : value}:30`}
            >{`${value.toString().length === 1 ? '0'+value : value}:30`}</Menu.Item>     
        </>
      );
    })
  }
    </Menu>
  );
 
  const selectRecurrenceOption = (e: any) => {
    let endDate = getEndDate(e.key, getData.rruleOption.repeat_every, getData.s_Date_Calender);
    getData.meetingDetail['recurrence'] = e.key;
    getData['e_Date_Calender'] = endDate;
    if(e.key !=="None" )
  {  let ruleIs = rRuleFrame(getData.rruleOption, e.key, getData.s_Date_Calender, endDate);
    setData({
      ...getData, meetingDetail:
        { ...getData.meetingDetail, recurrence: e.key, rrule: ruleIs.toString() }
      , e_Date_Calender: endDate, rruleText:ruleIs.toText()
    });
    }
    else {
           setData({
      ...getData, meetingDetail:
        { ...getData.meetingDetail, recurrence: e.key, rrule: "" }
      , e_Date_Calender: "", rruleText:"",isRecurring:false
    });
    }
  };

  // const selectRepeatOption = (e: any) => {

  //   let endDate = getEndDate(getData.meetingDetail.recurrence, e.key, getData.s_Date_Calender);
  //   getData.rruleOption['repeat_every'] = e.key;
  //   getData['e_Date_Calender'] = endDate;
  //   let ruleIs = rRuleFrame(getData.rruleOption, getData.meetingDetail.recurrence,
  //     getData.s_Date_Calender, endDate);
  //   setData({
  //     ...getData, rruleOption: {
  //       ...getData.rruleOption, repeat_every: e.key
  //     }
  //     , meetingDetail: {
  //       ...getData.meetingDetail, rrule: ruleIs.toString()
  //     }
  //     , e_Date_Calender: endDate, rruleText:ruleIs.toText()
  //   });
  // };

  const selectOccurenceOption = (e: any) => {
    setData({ ...getData, rruleOption: { ...getData.rruleOption, afteroccur: e.key } });
  };

  const selectMonthyonchangeEvent = (key: any, e: any) => {
    getData.rruleOption[key] = e.key;
    let ruleIs = rRuleFrame(getData.rruleOption, getData.meetingDetail.recurrence,
      getData.s_Date_Calender, getData.e_Date_Calender);
    setData({
      ...getData, rruleOption: { ...getData.rruleOption, [key]: e.key }
      , meetingDetail: { ...getData.meetingDetail, rrule: ruleIs.toString() }, rruleText:ruleIs.toText()
    });
  };

  const meetingTextBoxChanges = (key: string, e: any) => {
    setData({
      ...getData, meetingDetail: {
        ...getData.meetingDetail,
        [key]: (key === 'password') ? (e.target.value).trim() : e.target.value
      }
    });
  };


  const waitingRoomOnchange = (key: string, e: any) => {
    // if (key === 'is_participant_waiting_room') {
    //   setData({
    //     ...getData, meetingDetail: {
    //       ...getData.meetingDetail, [key]: e.target.checked,
    //       is_participant_join_bef_host: !e.target.checked
    //     }
    //   });
    // }
    // else {
      setData({
        ...getData, meetingDetail: {
          ...getData.meetingDetail, [key]: e.target.checked
        }
      });
    // }
  };

  const RecurringOnChange = (e: any) => {
    let endtAt = '';
    let checkbox = !getData.isRecurring
    if (!checkbox) {
      endtAt = getEndstring(getData.s_Date_Calender, getData.max_Time, getData.meetingDetail.isAmPM,
        getData.max_duration);
    }
    setData({
      ...getData, isRecurring:checkbox, endAt: endtAt,
      meetingDetail: { ...getData.meetingDetail, recurrence: "None",rrule:"" },rruleText:""
    });
  };

  const outsideMeetingDetail = (key: string, e: any) => {
    setData({ ...getData, [key]: e.target.checked });
  };

  const meetingDetailStore = (key: string, e: any) => {
    setData({ ...getData, meetingDetail: { ...getData.meetingDetail, [key]: e.target.checked } });
  };

  const calenderOnchange = (value: string) => {
    setData({ ...getData, meetingDetail: { ...getData.meetingDetail, calender_type: value } });
  };

  const joiningOptionOnchange = (value: string) => {
    setData({ ...getData, meetingDetail: { ...getData.meetingDetail, joining_option_type: value } });
  };

  const searchInput = (e: string) => {
    let searchText = e.toLowerCase();
    const filterZone: Array<any> = TIMEZONE
      .filter((value: any) => value.name.toLowerCase().includes(searchText));
    setData({ ...getData, timeZoneValue: filterZone });
  };

  const onMeetingIdChange = () => {
    if (currentWindowState === "editMeeting" || currentWindowState === "reschedule") {
      return;
    }
    setData({
      ...getData, meetingDetail: {
        ...getData.meetingDetail,
        is_use_personal_meeting_id: !getData.meetingDetail.is_use_personal_meeting_id
      }
    });
  };

  const rruleCheckBoxOnchange = () => {
    getData.rruleOption['value_disabled'] = !getData.rruleOption.value_disabled;
    let ruleIs = rRuleFrame(getData.rruleOption, getData.meetingDetail.recurrence,
      getData.s_Date_Calender,
      getData.e_Date_Calender);
    setData({
      ...getData, rruleOption: { ...getData.rruleOption, value_disabled: getData.rruleOption.value_disabled },
      meetingDetail: { ...getData.meetingDetail, rrule:  ruleIs.toString() }, rruleText:ruleIs.toText()
    });
  };

  const rruleMonthlyBoxOnchange = () => {
    getData.rruleOption['monthlyOccureon'] = !getData.rruleOption.monthlyOccureon;
    let ruleIs = rRuleFrame(getData.rruleOption, getData.meetingDetail.recurrence,
      getData.s_Date_Calender, getData.e_Date_Calender);
    setData({
      ...getData, rruleOption: { ...getData.rruleOption, monthlyOccureon: getData.rruleOption.monthlyOccureon },
      meetingDetail: { ...getData.meetingDetail, rrule:  ruleIs.toString() }, rruleText:ruleIs.toText()
    });
  };

  const handleDateChange = (value: any) => {
      getData['e_Date_Calender'] = value;
      if(value){let ruleIs = rRuleFrame(getData.rruleOption, getData.meetingDetail.recurrence,
        getData.s_Date_Calender, value);
      
      setData({
        ...getData,
        meetingDetail: { ...getData.meetingDetail, rrule:  ruleIs.toString() }
        , e_Date_Calender: value, rruleText:ruleIs.toText()
      });}
  };

  const selectDropDown = () =>{
   
   
    let element: HTMLElement | any = document.getElementById("meetSchedule") || null;

    if (element != null)  {
      if(element.hasAttribute('scroll') === true){
        element.removeAttribute("scroll");
        let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;

        if(hoverdiv)hoverdiv.style["display"] = "none";
        element.style["overflow-y"] = "overlay";

      }
      else{
        element.setAttribute("scroll", "no");
        let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;

        if(hoverdiv)hoverdiv.style["display"] = "block";

        element.style["overflow"] = "hidden";
      }
    };

  };



  const selectBoxOnchange = (val: any, obj: any) => {
      try{
      
            let participantDetails: any = [];
            let participantSipidList: any = [];
            obj.map((store: any) => {
            let data = JSON.parse(store.key);
            let HostDetail = {
            email: data.email_id,
            ext: data.ext,
            name: data.caller_id,
            profile_img: data.ImageURL,
            roletype: 3,
            sipid: data.sip_login_id,
            user_type: "company"
            };
            participantSipidList.push(parseInt(data.sip_login_id))
            participantDetails.push(HostDetail);
          });

        let loggedDetails: any = getData.existingParticipant[userdetails.sip_login_id];
        let filterdList: any = [];
           if(getData.alternateSipid && getData.alternateSipid.length > 0)
        {
             filterdList = _.filter(workContacts, function (o: any) {
          return o.sip_login_id !== parseInt(getData.alternateSipid[0]);
             });
        }
           else {
             filterdList = workContacts;
        }
           participantDetails.push(loggedDetails)
            setData({ ...getData, meetingDetail: { ...getData.meetingDetail, participants: participantDetails },  participantSipDetails:participantSipidList,searchKey:"",allContacts:filterdList});
          //  participantDetail(participantDetails,participantSipidList);
      
      }catch(e:any){
      console.log("selectBoxOnchange >>>>>", e)
      }
      
        
    };
  
    const searchContact = (e: string) => {
      let searchName = e.toLowerCase();
      if (searchName !== "") {
        let filtered = _.filter(getData.contacts, function (name: any) {
          return name.caller_id?.toLowerCase().includes(searchName) ||
            name.ext?.toString().includes(searchName) || name.team_name?.includes(searchName) ||
            name.email_id?.toLowerCase().includes(searchName);
        });
          let filtered_favs = _.filter(getData.favContactList, function (name: any) {
          return name.caller_id?.toLowerCase().includes(searchName) ||
            name.ext?.toString().includes(searchName) || name.team_name?.includes(searchName) ||
            name.email_id?.toLowerCase().includes(searchName);
        });
        setData({ ...getData, allContacts: filtered, searchKey: searchName,favContactList:filtered_favs });
      }
      else {
      
        if (getData.alternateSipid && getData.alternateSipid.length > 0) {

          let filterdList = _.filter(workContacts, function (o: any) {
          return o.sip_login_id !== parseInt(getData.alternateSipid[0]);
          });

          let filtered_favs=_.filter(favList, function (o: any) {
          return o.sip_login_id !== parseInt(getData.alternateSipid[0]);
          });
          
          setData({ ...getData, allContacts: filterdList, searchKey: searchName,favContactList:filtered_favs });
        } else { 
            setData({ ...getData, allContacts: workContacts, searchKey: searchName,favContactList:favList });
        }

        
      }
    };
  const timeListShow = timeDurationList.map((value: string, index: number) => {
    return (
      <>{index === 0 ?
        <>
          <Option value={'00:00'}
            key={`${index}:00`}>{`12:00`}</Option>
          <Option value={'00:30'}
            key={`${index}:30`}>{`12:30`}</Option>
        </>
        :
        <>
          <Option value={`${value.toString().length === 1 ? '0' + value : value}:00`}
            key={`${index}:00`}>{`${value.toString().length === 1 ? '0' + value : value}:00`}</Option>
          <Option value={`${value.toString().length === 1 ? '0' + value : value}:30`}
            key={`${index}:30`}>{`${value.toString().length === 1 ? '0' + value : value}:30`}</Option>
        </>
      }
      </>
    );
  });

  const durationListShow = allday.map((value: string, index: number) => {
    return (
      <>{index === 0 ?
        <>
          <Option value = {`${value}0: 30`}
            key={`${index}30`}>{`30m`}</Option>
        </>
        : (index > 11 ) ?
        <>
         <Option value={`${value.toString().length === 1 ? '0' + value  : value  }: 00`}
            key={`${index}:00`}>{`${value + 'h'}`}</Option>
        </> : 
          <>
             <Option value={`${value.toString().length === 1 ? '0' + value  : value  }: 00`}
            key={`${index}:00`}>{`${value + 'h'}`}</Option>
          {index !== 24 && <Option value={`${value.toString().length === 1 ? '0' + value  : value  }:30`}
            key={`${index}:30`}>{`${value + 'h'} 30m`}</Option>}
        </>
      }
      </>
    );
  });

  const onBlur = (e:any) =>{
    if (getData.meetingDetail.is_custom_password && getData.meetingDetail.password.length < 3)
    { toastInformation("password must be 3 or more character") }
  }  

  const finalMergeData = () => {
    try {
      if (getData.meetingDetail.title.trim() === "") { getData.meetingDetail.title = 'New Meeting'; }
      if (!getData.is_speaking_lang) { getData.meetingDetail.speakingLanguage="en"}
  let splitDuration: any = getData.max_duration.split(":");
      getData.meetingDetail.duration_minutes =  (60 * parseInt( splitDuration[0]))+ parseInt(splitDuration[1]);
      getData.meetingDetail.duration = { hours: splitDuration[0], minutes: splitDuration[1] };

      let newDate: Date = new Date(getData.s_Date_Calender);
      let splitHrMin = getData.max_Time.split(":");
    let timeFormat: any=getTimeFormatAMPM(splitHrMin,getData.meetingDetail.isAmPM);
    newDate.setHours(timeFormat);
      newDate.setMinutes(parseInt(splitHrMin[1]));
      getData.meetingDetail.start_timestamp = newDate.getTime();
      if (getData.meetingDetail.recurrence === "None") {
        let endDate: Date = new Date(newDate.getTime());
        endDate.setHours(endDate.getHours() + parseInt(getData.meetingDetail.duration.hours));
        endDate.setMinutes(endDate.getMinutes() + parseInt(getData.meetingDetail.duration.minutes))
        getData.meetingDetail.end_timestamp = endDate.getTime();
      }
      else { let endDate: Date = new Date(newDate.getTime());
        endDate.setHours(endDate.getHours() + parseInt(getData.meetingDetail.duration.hours));
        endDate.setMinutes(endDate.getMinutes() + parseInt(getData.meetingDetail.duration.minutes))
        getData.meetingDetail.end_timestamp = endDate.getTime();}

      getData.meetingDetail.time = {
        hours: (getData.max_Time).split(":")[0],
        minutes: (getData.max_Time).split(":")[1]
      };
      /* if (currentWindowState !== "editMeeting" || currentWindowState !== 'useTemplate') {
        let currentUserInfo = getPersonalData();
        getData.meetingDetail.participants.push(currentUserInfo);
      } */

      if(!getData.meetingDetail.is_alternate_host && alternateHost){
let findAltHostIdx:any=_.findIndex(getData.meetingDetail.participants, ((elem: any) => { return elem.roletype === 2 }));

if(findAltHostIdx > -1){
  getData.meetingDetail.participants.splice(findAltHostIdx,1);
}
      }
      if(!getData.meetingDetail.is_alternate_host && alternateHost){
let findAltHostIdx:any=_.findIndex(getData.meetingDetail.participants, ((elem: any) => { return elem.roletype === 2 }));
if(findAltHostIdx > -1){
  getData.meetingDetail.participants.splice(findAltHostIdx,1);
}
      }
 
            if (!getData.meetingDetail.is_custom_password && getData.meetingDetail.password !== "") {
             getData.meetingDetail.password = "";
      }
      return getData.meetingDetail;
    }
    catch (e: any) {
      toastInformation("Something went wrong Please try again", "failure");
    }
  };

  const editMeetingByUuid = () => {
    
    setData({ ...getData, buttonEnableStatus: true })
     let finalData: any = finalMergeData();
    if (currentWindowState === 'editMeeting' || currentWindowState === 'reschedule' || currentWindowState === "useTemplate") {
      let currentTime = new Date().setTime(new Date().getTime() - 1000 * 30)
      if (currentTime > getData.meetingDetail.start_timestamp) {
        toastInformation("meeting time should be greater than current time", "failure");
        setData({ ...getData, buttonEnableStatus: false })
        return;
      }
      else if (getData.max_Time === "") {
        toastInformation("meeting time should not be empty", "failure");
        setData({ ...getData, buttonEnableStatus: false })
        return;
      }
      else if (getData.meetingDetail.is_custom_password && getData.meetingDetail.password.trim() === "") {
        toastInformation("You have enabled custom password,Password should not be empty", "failure");
        setData({ ...getData, buttonEnableStatus: false })
        return;
      }
      else if (getData.meetingDetail.is_alternate_host && getData.meetingDetail.alternate_host.length === 0) {
        toastInformation("You have enabled alternate host,alternate host should not be empty", "failure");
        setData({ ...getData, buttonEnableStatus: false })
        return;
      }
        else if (getData.meetingDetail.is_custom_password && getData.meetingDetail.password.length < 3)
  { 
    toastInformation("password must be 3 or more character");  
    setData({...getData,buttonEnableStatus:false})
      return;
  }
  else{
    console.log("else called");
  }
    }

   
if(currentWindowState === 'editMeeting' || currentWindowState === 'reschedule')
{
  editMeetingApi(detailPage.uuid, finalData).then((response: any) => {
        if (response?.statusCode === 200) {
          setData({...getData,buttonEnableStatus:false})
          new meetingSDK.MeetingRestService().getMeetingsByUuid(response.uuid).then((res:any) => {
            if (res?.statusCode === 200) {
               storeMeetingPage(res.result);
               storeWindowState("meetingDetails");
             }
           })
           store.dispatch({
            type: Types.VIDEOMEET_COUNT_STATUS,
            payload: {
              meetingCountStatus:true
            }
          })
          updateMeetingRead(detailPage?.uuid);
          toastInformation(response.message, "success");
          calendarType(finalData,detailPage.invite_url);
    }
        else {
          setData({...getData,buttonEnableStatus:false})
    }
      });
     }   
    // }
    else if (currentWindowState === 'useTemplate') {
        const { recurrenceId, current_timestamp, ...other } = finalData;
     return new Promise((resolve, reject) => {
       new meetingSDK.MeetingRestService().createMeeting(other).then((result: any) => {
        if (result?.statusCode === 200) {
        setData({...getData,buttonEnableStatus:false})
        calendarType(finalData, result.inviteUrl);
        toastInformation("Meeting created successfully", "success");
        store.dispatch({
          type: Types.VIDEOMEET_COUNT_STATUS,
          payload: {
            meetingCountStatus:true
          }
        })
          updateMeetingRead(result?.uuid);
          // storeWindowState('mainPage');
         
        let data: any = {};
        data.offset = 0;
        data.limit = 10;
        data.filter = getListInput.filter;
        data.searchText = '';
        data.sort =getListInput.sort;
        getMeetingLists(data); 
         new meetingSDK.MeetingRestService().getMeetingsByUuid(result.uuid).then((res:any) => {
           if (res?.statusCode === 200) {
              storeMeetingPage(res.result);
              storeWindowState("meetingDetails");
            }
          })
      }
        else {
               setData({...getData,buttonEnableStatus:false})
          toastInformation(result.message, "failure");
        }
    })
      .catch((err: any) => {
        console.log("err>>", err);
        // toastInformation(err, "failure");
        setData({ ...getData, buttonEnableStatus: false });
        console.log("error is", err);
      });
     })    
   }

  };

    const handleJoin = (e:any)=>{
  let data = e.key === "0"?"Anyone" : e.key === "1"?"Only contacts" : "All signed in user"
    setData({ ...getData, meetingDetail: { ...getData.meetingDetail, authenticationJoin: data}});
  }
  const cancelMeeting = () => {

    setData({
      ...getData, isCancelMeetingModalVisible: true
    });
  };

  const cancelMeetingConfirm = () => {
    setData({
      ...getData, isCancelMeetingModalVisible: false
    });
    storeWindowState('mainPage');
  };

  // const participantDetail = (detail: any) => {
  //   detail.map((part:any, index:any) => {
  //     getData.participantSipDetails.push(part.sipid)
  //     let exis = getData.existingParticipant[part.sipid]
  //     if(exis){
  //       detail[index].roletype = exis.roletype
  //     }
  //   })
    
  //   let loggedDetails:any = getData.existingParticipant[userdetails.sip_login_id];

  //   detail.push(loggedDetails)

  
  //   setData({ ...getData,participantSipDetails:getData.participantSipDetails ,meetingDetail: { ...getData.meetingDetail, participants: detail } });
  // };

  const { TextArea } = Input;

  const setTime = (key: any, e: any) => {
    let endtAt: string = '';
    if (getData.meetingDetail.recurrence === "None" && !getData.isRecurring) {
      endtAt = getEndstring(getData.s_Date_Calender, e.target.value, getData.meetingDetail.isAmPM,
        getData.max_duration);
    }
    setData({ ...getData, [key]: e.target.value, endAt: endtAt });
  }
  const outPutLangSelectiondaily = (
    <Menu onClick={selectRecurrenceOption}>
      <Menu.Item key={"None"}>No Recurrence</Menu.Item>
      <Menu.Item key={"Daily"}>Daily</Menu.Item>
      <Menu.Item key={"Weekly"}>Weekly</Menu.Item>
      <Menu.Item key={"Monthly"}>Monthly</Menu.Item>
    </Menu>
  );

  let repeatCount = getData.meetingDetail.recurrence === "None" ? 0 :
    (getData.meetingDetail.recurrence === 'Daily' ? 15 :
      (getData.meetingDetail.recurrence === 'Weekly') ? 12 : 3);
  let repeatDay: any = Array.from(Array(repeatCount).keys());

  const selectOccurenceMenu = (
    <Menu onClick={selectOccurenceOption}>
      {repeatDay.map((list: any) => {
        return (<> <Menu.Item key={list + 1}>{list + 1}</Menu.Item></>);
      })}
    </Menu>
  );

  let monthlyDays: any = Array.from(Array(31).keys());
  const monthlyDayMenu = (
    <Menu onClick={(e: any) => selectMonthyonchangeEvent('occurOnDay', e)}>
      {monthlyDays.map((list: any) => {
        return (<> <Menu.Item key={list + 1}>{list + 1}</Menu.Item></>);
      })}
    </Menu>
  );
  // let Userjoin: any = Array.from(Array(31).keys());
  const UserJoinMenu = (
    <Menu  onClick={(e: any) => handleJoin(e)}
    items={[
      {
        label: <span>AnyOne </span>,
        key: 0
      },
      {
        label: <span>Only contacts </span>,
        key: 1
      },
      {
        label: <span>All signed in user</span>,
        key: 2
      }
      
    ]}
  />
  );
  let weekMode: any = ['First', 'Second', 'Third', 'Fourth', 'Last'];
  const weeklyModeOnchange = (
    <Menu onClick={(e: any) => selectMonthyonchangeEvent('monthlyWeek', e)}>
      {weekMode.map((list: any) => {
        return (<> <Menu.Item key={list}>{list}</Menu.Item></>);
      })}
    </Menu>
  );

  let monthMode: any = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const selectMonthDayOnchange = (
    <Menu onClick={(e: any) => selectMonthyonchangeEvent('monthlyDay', e)}>
      {monthMode.map((list: any) => {
        return (<> <Menu.Item key={list.substring(0, 3)}>{list}</Menu.Item></>);
      })}
    </Menu>
  );
  
  const textBoxSpecOnchange = (keyPress: any) => {
    setData({ ...getData, spech_Search: keyPress.target.value });
  };

  const handle_Spec_VisibleChange = (flag: any) => {
    setData({ ...getData, isSpeakView: flag });
  };
  const updateInputLanguage = (lan: string, code: string) => {
    setData({
      ...getData, ast_default_Spe_Opt: lan + " (" + code + ")", isSpeakView: false,
      meetingDetail: { ...getData.meetingDetail, speakingLanguage: code }
    });
  };

  const closeCancelMeetingModal = () => {
    setData({ ...getData, isCancelMeetingModalVisible: false });
  };

    const openParticipant =()=>{
    let status = getData.openParticipant;
    setData({
      ...getData, openParticipant: !status
    });
  }

     const contactFocus=()=>{
         if (getData.alternateSipid && getData.alternateSipid.length > 0) {

          let filterdList = _.filter(workContacts, function (o: any) {
          return o.sip_login_id !== parseInt(getData.alternateSipid[0]);
          });
          
          setData({ ...getData, allContacts: filterdList, searchKey: "" });
        } else { 
            setData({ ...getData, allContacts: workContacts, searchKey: "" });
        }
  };

  let ASR_Data: any = store.getState().ASR_Language || [];
  let asrSpecLanguage = asrSearchLanguage(ASR_Data.list, getData.spech_Search);
  const outPutLangSelection = (
    <div className={styles.autoTranslateLangs}>
      <span className={styles.topsecTxtTitle}>Set Your Speaking language</span>
      <div className={styles.searchBox}><URInput placeHolder='Search'
        className='searchBoxlanglist' onChange={textBoxSpecOnchange} /></div>
      <ul className={`scroller ${styles.langList}`}>
        {asrSpecLanguage.map((elem: any, index: number) => {
          return (<li key={index} className={(getData.ast_default_Spe_Opt?.includes(elem.languageName)) ? styles.selected : ""}
            onClick={() => updateInputLanguage(elem.languageName, elem.languageCode)}>
            {(getData.ast_default_Spe_Opt?.includes(elem.languageName)) &&
              <span className="icon_tick"></span>}
            {elem.languageName + " (" + elem.languageCode + ")"}</li>);
        })
        }
      </ul>
    </div>
  );
  return (
    <>
      <div className={styles.mainInnerConSec}>
        <div className={styles.meetingformCon}>
          <div className={styles.topmeethead}>
            <h4>Meeting Details</h4>
          </div>

          <div className={styles.formGroup}>
            <div className={styles.scheduleTitle}>
              <URInput placeHolder="Enter meeting title" name="" className={`inputcustomBox newFocusGreen ${styles.custIn}`}
                value={getData.meetingDetail.title}
                onChange={(e: any) => meetingTextBoxChanges('title', e)}  maxLength={80}/>
                {/*  <span className={styles.inrequirputright}>{80 - getData.meetingDetail.title.length}</span> */}
            </div>
            <div className={styles.txtareacon}>
              <TextArea rows={3} placeholder="Meeting Description" className="customTextareaBox"
                value={getData.meetingDetail.description}
                onChange={(e: any) => meetingTextBoxChanges('description', e)} maxLength={250}/>
            </div>
          </div>


          {!getData.openParticipant && <div className={`${styles.participantTop} ${styles.linktopheader}`}>
            <div className={styles.userName}  onClick={openParticipant} >
              <span className="icon_plus"></span>
              <label>Participant</label> </div>
          </div> } 
        {getData.openParticipant &&  <div className={`${styles.participantTop} ${styles.leftpartbtmside}`}>
            <div className={styles.userName}><span className="icon_profile"></span>
              Participant <span className={styles.titleHost}>{`(${getData?.participantSipDetails?.length})`}</span></div>
          </div>}  
         {getData.openParticipant &&  <div className={styles.participantdropcus}>
          <div className={styles.insideicon}>
              {getData.participantSipDetails.length === 0 && <img src={taskimg2} alt="" />}
               <Select 
              /*  labelInValue = {true} */
                mode='multiple'
                style={{ width: '100%' }}
                placeholder="Select contacts or add email by comma seperation"
                   className={getData.participantSipDetails.length === 0 ? "newselects taskcreations customdropbox ":"newselects taskcreations customdropbox inputselectlftnone"}
                dropdownClassName="newChatSel meetingdropdown"
               /*  optionLabelProp="label" */
                value={getData.participantSipDetails}
                showSearch={true}
                filterOption={false}
               onDropdownVisibleChange={selectDropDown}
                  onChange={selectBoxOnchange}
                 onSearch={searchContact}  
                 onFocus={contactFocus}
                > 

                {/* {allcontact} */}
                {/* { (favList?.length > 0 &&getData.searchKey==='') && 
          <div className="titlesdrop">Favourite / Frequently Contacted</div>}
                  {favList?.map((contactName: any, index: any) => {

            return <div key={index}>
              <div className="dropdowndesign">
                <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                  profileInfo={
                    (contactName.ImageURL !== null && contactName.ImageURL !== "") ?
                      (<>
                        <img src={contactName.ImageURL} alt="" />
                        <URStatusDot className={ userStatusColor(contactName.user_status,'small')}/></>) :
                      (<>
                        <span>{contactName?.caller_id?.charAt(0).toUpperCase()} </span>
                        <URStatusDot className={ userStatusColor(contactName.user_status,'small')} />
                      </>)
                  } />
                <div className="names">{contactName.caller_id}</div>
                <div className="ext">{contactName.ext }</div>
              </div>
            </div>;
          })} */}

                {/* {getData.allContacts?.length > 0 &&  <div className="titlesdrop">Contact</div>} */}

                             { (favList?.length > 0) && 
          <div className="titlesdrop">Favourite / Frequently Contacted</div>}
                  {getData.favContactList?.map((favcontactName: any, index: any) => {
               
            return  <div key={index} value={favcontactName.sip_login_id}>
        
              <div className="dropdowndesign">
                <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                  profileInfo={
                    (favcontactName.ImageURL !== null && favcontactName.ImageURL !== "") ?
                      (<>
                        <img src={favcontactName.ImageURL} alt="" />
                        <URStatusDot className={ userStatusColor(favcontactName.user_status,'small')}/></>) :
                      (<>
                        <span>{favcontactName?.caller_id?.charAt(0).toUpperCase()} </span>
                        <URStatusDot className={ userStatusColor(favcontactName.user_status,'small')} />
                      </>)
                  } />
                <div className="names">{favcontactName.caller_id}</div>
                <div className="ext">{favcontactName.ext }</div>
              </div>
            </div>;
          })} 
                {getData.allContacts?.map((contactName: any, index: any) => {
                  let highlighted: any = searchHighlight(contactName, getData.searchKey);
                  return <Option key={JSON.stringify(contactName)} value={contactName.sip_login_id}>
                                   {
                ((getData.allContacts[index - 1]?.caller_id)?.charAt(0).toUpperCase()) !==
                ((contactName?.caller_id)?.charAt(0).toUpperCase()) &&
                <div className="titlesdrop">{(contactName?.caller_id)?.charAt(0).toUpperCase()} </div>
              }
                    <div className="dropdowndesign">
                      <div className="usergroupss">
                        <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                          profileInfo={
                            (contactName.ImageURL !== null && contactName.ImageURL !== "") ?
                              (<>
                                <img src={contactName.ImageURL} alt="" className={styles.imgSelected} />
                                <URStatusDot className={userStatusColor(contactName.user_status, 'small')} /></>) :
                              (<>
                                <span>{contactName?.caller_id?.charAt(0).toUpperCase()} </span>
                                <URStatusDot className={userStatusColor(contactName.user_status, 'small')} />
                              </>)
                          } />
                      </div>
                      {getData.searchKey !== '' ?
                        <div className="names">{(highlighted?.middleMsg !== "") ? (<>{highlighted?.firstMsg}
                          <b className={styles.highlight}>{highlighted?.middleMsg}</b>
                          {highlighted?.lastMsg}</>) : 
                          (<>{contactName?.caller_id}</>)}</div> :
                        <div className="names">{contactName.caller_id}</div>}
                      <div className="ext">{contactName.ext}</div>
                    </div>
                  </Option>;
                })}  
              </Select>
            </div>
          </div> } 

          <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
            <div className={styles.meettimetxt}>
              {getData.meetingDetail.recurrence === "None" && <p>{getData.endAt}</p>}
            </div>
            <div className={styles.filterconmain}>

              <div className={`${styles.leftdatefil} ${styles.lfttopfil}`}>
                <div className={styles.shareSelect}>


                  {/* <DatePicker className="customDatepicker" format={'DD MMM YYYY'}
                    disabledDate={(e) => disabledStartDate(new Date(), e)}
                    defaultValue={moment(getData.s_Date_Calender,'DD MMM YYYY')}
                    dropdownClassName='datepickerDropdown' placeholder='Start date' onChange={dateTimeSelectOpt}/> */}


                  {/* <DatePicker className="customDatepicker meetingdate meetlfticonremove" format={'DD MMM YYYY'}
                     disabledDate={(e) => disabledStartDate(new Date(), e)}  */}
                   {/* disabledDate={(current) => {
              let customDate = moment().format("YYYY-MM-DD");
              return current && current < moment(customDate, "YYYY-MM-DD");
            }}   */}
                    {/* onChange={dateTimeSelectOpt}
                    defaultValue={moment(currentWindowState === 'reschedule'?new Date():getData.s_Date_Calender, "DD MMM YYYY")}
                    //defaultValue={moment(new Date(getData.s_Date_Calender))}
                    //defaultValue={moment(getData.s_Date_Calender)}
                    //value={moment(getData.s_Date_Calender)}
                    dropdownClassName='datepickerDropdown meetingDropdwn'
                    placeholder='Start date' /> */}
                                  <DatePicker className="customDatepicker meetingdate meetlfticonremove" format={'DD MMM YYYY'}
                            disabledDate={(e) => disabledEndDate(new Date(getData.s_Date_Calender), e)}
                            defaultValue={moment(getData.s_Date_Calender)}
                            dropdownClassName='datepickerDropdown meetingDropdwn'
                            placeholder='Start date' onChange={dateTimeSelectOpt}
                            disabled={getData.rruleOption.value_disabled === true ? false : true} />
                </div>
              </div>

              <div className={`${styles.righttimefil} ${styles.righttopfil}`}>
                <div className={styles.rightfilter}>
                  <label className={styles.colformLabel}>Starts</label>
                  {/* <div className={styles.shareSelect}>
                    <Select className="langSelSec cusSelDrp" defaultValue={getData.max_Time}
                      dropdownClassName='customSelectdrp' onDropdownVisibleChange={eeditselectDropDown}
                      style={{ width: 200 }} onChange={(e: any) => defaultValueOnchange('max_Time', e)}>
                      {timeListShow}
                    </Select>
                  </div>   */}
                   <div className={styles.clocktimiconsec}>
                    {/* <Select className="langSelSec cusSelDrp" defaultValue={getData.max_Time}
                      dropdownClassName='customSelectdrp'
                      style={{ width: 200 }} onChange={(e: any) => defaultValueOnchange('max_Time', e)} onDropdownVisibleChange={selectDropDown}>
                      {timeListShow}
                    </Select> */}
                    <input className={`${styles.timeEdit} ${(timepickEdit) ? styles.jhds : ''}`} type="time" id="appt" name="appt"
                      min="01:00" max="12:00" step="1800" required onChange={(e: any) => setTime("max_Time", e)} value={getData.max_Time}/>
                      {/* <span className="icon_down-arrow"></span> */}
                      <Dropdown overlay={timePickerNew} trigger={['click']} className={styles.tpicker} overlayClassName="tPickeroverlay" placement="bottomRight" 
                      onVisibleChange={handletimeedit}
                      getPopupContainer={trigger => trigger.parentNode} 
 
                      visible={timepickEdit}>
                        <span className="icon_down-arrow"></span>
                      </Dropdown>
                  </div>

                  <div className={styles.shareSelect}>
                    <Select className="langSelSec cusSelDrp newGreenbdr" defaultValue={getData.meetingDetail.isAmPM}
                      dropdownClassName='customSelectdrp' onDropdownVisibleChange={selectDropDown}
                      style={{ width: 200 }} onChange={am_TO_pm_Onchange}>
                      {
                        ['AM', 'PM'].map((value: any, index: number) =>
                          <Option value={value}
                            key={index}>{`${value}`}</Option>)
                      }
                    </Select>
                  </div>
                </div>
              </div>

              <div className={styles.rightfilter}>
                <label className={styles.colformLabel}>Duration</label>
                <div className={styles.shareSelect}>
                  <Select className="langSelSec cusSelDrp newGreenbdr" 
                    value={getMaxDurationFormat(getData.max_duration)}
                    dropdownClassName='customSelectdrp'
                     onDropdownVisibleChange={selectDropDown}
                    style={{ width: 200 }}
                     onChange={(e: any) => defaultValueOnchange('max_duration', e)}>
                        {durationListShow}
                  </Select>
                </div>
              </div>

            </div>
          </div>

          <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
            <div className={styles.timelfttopfil}>
              <div className={styles.shareSelect}>

                <Select
                  style={{ width: '100%' }}
                  defaultValue={getData.meetingDetail.timezone}
                  placeholder="Select timezone"
                  onChange={timeZoneOnchange}
                  filterOption={false}
                  showSearch={true}
                  onDropdownVisibleChange={selectDropDown}
                  className="selTimezone cusSelDrp timezonedrpdwn"
                  dropdownClassName='customSelectdrp'
                  onSearch={(e: string) => searchInput(e)}>
                  {
                    getData.timeZoneValue.map((d: any) =>
                      <Option value={d.name}
                        key={d.id}>{`${d.name}`}</Option>)
                  }
                </Select>

              </div>
            </div>
          </div>

          <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
            <div className={styles.radiomeet}>
              <div className={styles.radiospacealign}>
                <div className={`overwriteRadio ${styles.widthsmall}`} onClick={() => calenderOnchange('google')}>
                  <URRadio checked={getData.meetingDetail.calender_type === 'google' ? true : false}
                     />
                  <span>Google Calendar</span>
                </div>
                
                <div className={`overwriteRadio ${styles.widthsmall}`} onClick={() => calenderOnchange('outlook')}>
                  <URRadio checked={getData.meetingDetail.calender_type === 'outlook' ? true : false}
                     />
                  <span>Outlook Calendar</span>
                </div>
                <div className={`overwriteRadio ${styles.widthsmall}`} onClick={() => calenderOnchange('iCalendar')}>
                  <URRadio checked={getData.meetingDetail.calender_type === 'iCalendar' ? true : false}
                     />
                  <span>Download .ics</span>
                </div>
                <div className={`overwriteRadio ${styles.widthsmall}`}  onClick={() => calenderOnchange('none')}>
                  <URRadio checked={getData.meetingDetail.calender_type === 'none' ? true : false}
                    />
                  <span>None</span>
                </div>
              </div>
            </div>
          </div>

          <div className={`${recurrenceMeetingBtn ? `${styles.formGroup} ${styles.marBtmmax} disabledIcon` :`${styles.formGroup} ${styles.marBtmmax}`}`}>
            <div className={styles.checkmeet}>
              <URCheckBox checked={getData.isRecurring}
                onChange={RecurringOnChange} />
              <span className={styles.reguremeetxt} onClick={RecurringOnChange}>Recurring Meeting</span>

              {(getData.isRecurring && getData.meetingDetail.recurrence !== "None") &&
                <span className={styles.eventdaytxt}>{getData.rruleText}</span>
              }

            </div>
            {getData.isRecurring &&

              <div className={styles.recuringinnerConsec}>
                <div className={`${styles.recuringtopsec} ${styles.marbtmmin} ${styles.recurpadlft}`}>
                  <div className={styles.lftsidedrop}>
                    <div><span>Recurrence</span></div>
                    <div>
                      <div className={styles.shareSelect}>
                        <Dropdown overlay={outPutLangSelectiondaily} placement="bottomRight" trigger={['click']}
                        overlayClassName='customdrpBox'
                        className="cusBoxDrp"
                        >
                          <div className={`${styles.langSelSec} ${styles.daily}`}>
                            <span>{getData.meetingDetail.recurrence}</span>
                            <span className="icon_downarrow2"></span>
                          </div>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                  {getData.meetingDetail.recurrence !== "None" &&
                    <div className={styles.lftsidedrop}>
                      <div><span>Repeat every</span></div>

                      <div>
                        <div className={styles.shareSelect}>
                        <Dropdown overlay={UserJoinMenu} placement="bottomRight" trigger={['click']}
                        
                            overlayClassName='customdrpBox'
                            className="cusBoxDrp">
                            <div className={`${styles.langSelSec} ${styles.every}`}>
                            <span>{detailPage.rrule  ? editRRule?.options?.interval : "1"}</span>
                              <span className="icon_downarrow2"></span>
                            </div>
                          </Dropdown>
                        </div>
                      </div>
                      <div><span>{getData.meetingDetail.recurrence}</span></div>
                    </div>
                  }
                </div>
                {getData.meetingDetail.recurrence === 'Weekly' &&
                <div className={styles.daySelect}>
                <div className={styles.daySelectTit}><span>Occurs on</span></div>
                  <div className={`${styles.recuringtopsec} ${styles.marbtmmin} `}>
                    <div className={`${styles.checkmeet} ${styles.checpadright}`}>
                      {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((value: any, index: any) =>
                        <div key={index} className={styles.dateHalf}><URCheckBox key={index}
                          checked={getData.rruleOption.weeklyOccuron.indexOf(value) !== -1}
                          onChange={(e: any) => updateMultiCheckbox(value)} />
                          <span className={styles.reguremeetxt}>{value}</span></div>
                      )
                      }
                    </div>
                    </div>
                  </div>}
                {getData.meetingDetail.recurrence === 'Monthly' &&
                  <div className={`${styles.recuringtopsec} ${styles.marbtmmin} `}>
                    <div className={styles.checkdaydrop}>
                      <div>
                        <div className={`overwriteRadio ${styles.widthsmall}`}>
                          <URRadio checked={getData.rruleOption.monthlyOccureon}
                            onChange={rruleMonthlyBoxOnchange} /> <span>Day</span>
                        </div>
                      </div>
                      <div>
                    <div className={styles.shareSelect}>
                        <Dropdown overlay={monthlyDayMenu} placement="bottomRight" trigger={['click']}
                          overlayClassName='customdrpBox'
                          className="cusBoxDrp">
                            <div className={`${styles.langSelSec} ${styles.every}`}>
                              <span>{getData.rruleOption.occurOnDay}</span>
                              <span className="icon_downarrow2"></span>
                            </div>
                          </Dropdown>
                        </div>
                      </div>
                      <div><span>Of the month</span></div>
                    </div>
                  </div>}
                {getData.meetingDetail.recurrence === 'Monthly' &&
                  <div className={`${styles.recuringtopsec} ${styles.marbtmmin} `}>
                    <div className={styles.checkdaydrop}>
                      <div>
                        <div className={`overwriteRadio ${styles.widthsmall}`}>
                          <URRadio checked={!getData.rruleOption.monthlyOccureon}
                            onChange={rruleMonthlyBoxOnchange} />
                        </div>
                      </div>
                      <div>
                        <div className={styles.shareSelect}>
                          <Dropdown overlay={weeklyModeOnchange} placement="bottomRight" trigger={['click']}>
                            <div className={`${styles.langSelSec} ${styles.every}`}>
                              <span>{getData.rruleOption.monthlyWeek}</span>
                              <span className="icon_downarrow2"></span>
                            </div>
                          </Dropdown>
                        </div>
                      </div>
                      <div>
                        <div className={styles.shareSelect}>
                          <Dropdown overlay={selectMonthDayOnchange} placement="bottomRight" trigger={['click']}>
                            <div className={`${styles.langSelSec} ${styles.days}`}>
                              <span>{getData.rruleOption.monthlyDay}</span>
                              <span className="icon_downarrow2"></span>
                            </div>
                          </Dropdown>
                        </div>
                      </div>
                      <div><span>Of the month</span></div>
                    </div>
                  </div>}

                {getData.meetingDetail.recurrence !== 'None' &&
                  <div className={`${styles.recuringtopsec} ${styles.marbtmmin}`}>
                    <div className={styles.lftsidedrop}>
                      <div>
                        <div className={`overwriteRadio ${styles.widthsmall}`}>
                          <URRadio checked={getData.rruleOption.value_disabled}
                            onChange={rruleCheckBoxOnchange} /> <span>By end date</span>
                        </div>
                      </div>
                      <div>
                        <div className={styles.datepickerctst}>
                          <DatePicker className="customDatepicker meetingdate" format={'DD MMM YYYY'}
                            disabledDate={(e) => disabledEndDate(new Date(getData.s_Date_Calender), e)}
                            value={getData.e_Date_Calender !== null? moment(getData.e_Date_Calender):null}
                            dropdownClassName='datepickerDropdown meetingDropdwn'
                            placeholder='End date' onChange={handleDateChange}
                            disabled={getData.rruleOption.value_disabled === true ? false : true} />
                        </div>
                      </div>
                    </div>
                    <div className={styles.lftsidedrop}>
                      <div>
                        <div className={`overwriteRadio ${styles.widthsmall}`}>
                          <URRadio checked={!getData.rruleOption.value_disabled}
                            onChange={rruleCheckBoxOnchange} /> <span>After</span>
                        </div>
                      </div>
                      <div>
                        <div className={styles.shareSelect}>
                          <Dropdown overlay={selectOccurenceMenu} placement="bottomRight" trigger={['click']}
                            overlayClassName='customdrpBox'
                            className="cusBoxDrp">
                            <div className={`${styles.langSelSec} ${styles.every}`}>
                              <span>{getData.rruleOption.afteroccur}</span>
                              <span className="icon_downarrow2"></span>
                            </div>
                          </Dropdown>
                        </div>
                      </div>
                      <div><span>Occurrence(s)</span></div>
                    </div>
                  </div>
                }

              </div>
            }
          </div>

          {/* <div className={styles.moredetailstxt}  onClick={moreOptionTrigger}>
            <h4>More Details <span className={getData.isMoreDetail ? "icon_uparrow" : "icon_downarrow2"}
             ></span></h4>
          </div>

          {getData.isMoreDetail &&
            <> */}
              <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
                <div className={styles.radiomeet}>
                  <div className={styles.radiospacealign}>
                    <div className={`overwriteRadio ${styles.widthsmall}`} onClick={onMeetingIdChange}>
                    <URRadio checked={getData.meetingDetail.is_use_personal_meeting_id ? false : true}
                       disabled={(currentWindowState !== "useTemplate" && getData.meetingDetail.is_use_personal_meeting_id) ? true : false}/>
                      <span>Generate a random meeting ID</span>
                    </div>
                    <div className={`overwriteRadio ${styles.widthsmall}`} onClick={onMeetingIdChange}>
                      <URRadio checked={getData.meetingDetail.is_use_personal_meeting_id}
                         disabled={(currentWindowState !== "useTemplate" && !getData.meetingDetail.is_use_personal_meeting_id) ? true : false}/>
                      <span>Personal Meeting ID ({getData.meetingDetail.personal_meeting_id})</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
                <div className={styles.passmeet}>
                  <div className={styles.passwordconsec} >
                    <div onClick={() => updateMeetingDetail('is_custom_password',!getData.meetingDetail.is_custom_password)}>
                      <URCheckBox checked={getData.meetingDetail.is_custom_password}
                         onChange={(e: any) => meetingDetailStore('is_custom_password', e)} />
                      <label className={styles.passtxt}>Password</label>
                    </div>
                    {getData.meetingDetail.is_custom_password &&
                      <div>
                        <Input placeholder="Enter password" maxLength={16}
                         className={` ${getData.meetingDetail.is_custom_password ? `${styles.formControl} ${styles.passInput}` : `${styles.formControl} ${styles.passInput} ${styles.disabledcus}`}  `}
                        value={getData.meetingDetail.password} onBlur={onBlur}
                          onChange={(e: any) => meetingTextBoxChanges('password', e)} disabled={!getData.meetingDetail.is_custom_password ? true :false} />
                      </div>}
                  </div>
                  <p className={styles.userendpass}>Only user who enter password can join the meeting</p>
                </div>
              </div>
              <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
                <div className={styles.radiomeetlink}>
                  <div className={styles.radiospacealign}>
                    <div className={`overwriteRadio ${styles.widthsmall}`} onClick={(e: any) => joiningOptionOnchange('link')}>
                      <URRadio checked={getData.meetingDetail.joining_option_type === 'link' ? true : false}
                         /> <span>Link</span>
                    </div>
                    <div className={`overwriteRadio ${styles.widthsmall}`} onClick={(e: any) => joiningOptionOnchange('dailIn')}>
                      <URRadio checked={getData.meetingDetail.joining_option_type === 'dailIn' ? true : false}
                         /> <span>Link and Dial In</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
                <div className={styles.switchtogglebtncon}>
                  <div className={styles.switchtodleconsec} >
                    <div className={styles.lfttoggle} onClick={()=>updateMeetingDetail("is_host_myvideo",!getData.meetingDetail.is_host_myvideo)}>
                      <Switch size="small" checked={getData.meetingDetail.is_host_myvideo}
                         onChange={(e: any) => videoShowHideStatus('is_host_myvideo', e)}/>
                      <span >{!getData.meetingDetail.is_host_myvideo ? 'OFF' :'ON' }</span>
                      <label >(Host)</label>
                    </div>
                    <p className={styles.offtoglebtm}>Initially, host video in turned OFF</p>
                  </div>
                  <div className={styles.switchtodleconsec} >
                    <div className={styles.lfttoggle} onClick={()=>updateMeetingDetail('is_participant_video',!getData.meetingDetail.is_participant_video)}>
                      <Switch size="small" checked={getData.meetingDetail.is_participant_video}
                         onChange={(e: any) => videoShowHideStatus('is_participant_video', e)} />
                      <span >{!getData.meetingDetail.is_participant_video ? "OFF" : "ON"}</span>
                      <label >(Participants)</label>
                    </div>
                    <p className={styles.offtoglebtm}>Initially, Participants video in turned OFF</p>
                  </div>
                </div>
              </div>
              <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
                <div className={styles.checkwaitingroom} onClick={()=>updateMeetingDetail('is_participant_waiting_room',!getData.meetingDetail.is_participant_waiting_room)}>
                  <div className={styles.lftcheckconsec}>
                    <URCheckBox checked={getData.meetingDetail.is_participant_waiting_room}
                       onChange={(e: any) => waitingRoomOnchange('is_participant_waiting_room', e)}></URCheckBox>
                    <span className={styles.waitxtlft}>Waiting Room</span>
                  </div>
                  <p className={styles.WaitingTxt}>Only participants admitted by the host can join the meeting</p>
                </div>
          </div>
          
          <div className={styles.moredetailstxt}  onClick={moreOptionTrigger}>
            <h4>More Details <span className={getData.isMoreDetail ? "icon_uparrow" : "icon_downarrow2"}
             ></span></h4>
          </div>

          {getData.isMoreDetail &&
            <>
              
           
              <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
                <div className={styles.checkwaitingroom} onClick={()=>updateMeetingDetail('is_record_meeting',!getData.meetingDetail.is_record_meeting)}>
                  <div className={styles.lftcheckconsec}>
                    <URCheckBox checked={getData.meetingDetail.is_record_meeting}
                     onChange={(e: any) => meetingDetailStore('is_record_meeting', e)} ></URCheckBox>
                    <span className={styles.waitxtlft}>Record my meeting in (UR Cloud)</span>
                  </div>
                  <p className={styles.WaitingTxt}>50% Consumed, We have scope to upsell the storage add-on here.</p>
                </div>
              </div>
              <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
                <div className={styles.checkwaitingroom}>
                  <div className={styles.lftcheckconsec}  onClick={()=>updateMeetingDetail('is_participant_join_bef_host',!getData.meetingDetail.is_participant_join_bef_host)}>
                    <URCheckBox checked={getData.meetingDetail.is_participant_join_bef_host}
                     onChange={(e: any) => waitingRoomOnchange('is_participant_join_bef_host', e)}></URCheckBox>
                    <span className={styles.waitxtlft}>Allow participants join before host enters</span>
                  </div>
                </div>
              </div>
              <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
                <div className={styles.checkwaitingroom}>
                  <div className={styles.lftcheckconsec} onClick={()=>updateMeetingDetail('is_participant_invite_guest',!getData.meetingDetail.is_participant_invite_guest)}>
                    <URCheckBox checked={getData.meetingDetail.is_participant_invite_guest}
                       onChange={(e: any) => meetingDetailStore('is_participant_invite_guest', e)}></URCheckBox>
                    <span className={styles.waitxtlft}>Allow participants to invite guests</span>
                  </div>
                </div>
              </div>

              <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
                <div className={styles.checkwaitingroom}>
                  <div className={styles.lftcheckconsec} onClick={()=>updateMeetingDetail('is_participant_mute_entry',!getData.meetingDetail.is_participant_mute_entry)}>
                    <URCheckBox checked={getData.meetingDetail.is_participant_mute_entry}
                      onChange={(e: any) => meetingDetailStore('is_participant_mute_entry', e)} ></URCheckBox>
                    <span className={styles.waitxtlft}>Mute participants audio upon entry</span>
                  </div>
                </div>
              </div>

              <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
                <div className={styles.checkwaitingroom}>
                  <div className={styles.lftcheckconsec}>
                    <URCheckBox checked={getData.is_speaking_lang}
                       onChange={(e: any) => outsideMeetingDetail('is_speaking_lang', e)}></URCheckBox>
                    <span className={styles.waitxtlft} onClick={()=>updateStatus('is_speaking_lang',!getData.is_speaking_lang)}>Meeting common speaking language.</span>
                  </div>
                </div>

                {getData.is_speaking_lang &&
                  <div className={styles.meetlngspeach}>
                    <div className={styles.shareSelect}>
                      <Dropdown overlay={outPutLangSelection} placement="bottomRight" trigger={['click']}
                        onVisibleChange={handle_Spec_VisibleChange}
                        visible={getData.isSpeakView}>
                        <div className={styles.langSelSec}>
                          <span>{getData.ast_default_Spe_Opt}</span>
                          <span className="icon_downarrow2" onClick={() => handle_Spec_VisibleChange(true)}></span>
                        </div>
                      </Dropdown>
                    </div>
                  </div>
                }
              </div>

              <div className={`${alternateHostBtn ? `${styles.formGroup} ${styles.marBtmmax} disabledIcon` :`${styles.formGroup} ${styles.marBtmmax}`}`}>
                <div className={styles.checkwaitingroom}>
                  <div className={styles.lftcheckconsec}> 
                    <URCheckBox checked={getData.meetingDetail.is_alternate_host}
                       onChange={(e: any) => meetingDetailStore('is_alternate_host', e)}></URCheckBox>
                    <span className={styles.waitxtlft}  onClick={()=>updateMeetingDetail('is_alternate_host',!getData.meetingDetail.is_alternate_host)}>Alternative Host</span>
                  </div>
                </div>

                {getData.meetingDetail.is_alternate_host &&
                  <div className={styles.meetlngspeach}>
                  <SingleParticipantList alternativeHost={alternativeHost}
                    participantSipDetails={getData.participantSipDetails} alternateHostDetails={ getData.alternateSipid} ></SingleParticipantList>
                  </div>
                }
              </div>
              <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
                <div className={`${styles.checkwaitingroom} ${styles.anycheckconsectop}`}>
                <div className={styles.lftcheckconsec} >
                      <URCheckBox checked={getData.meetingDetail.requireAuthentication}
                      onChange={(e: any) => meetingDetailStore('requireAuthentication', e)} ></URCheckBox>
                    <span className={styles.waitxtlft}  onClick={()=>updateMeetingDetail('requireAuthentication',!getData.meetingDetail.requireAuthentication)}>Require Authentication to join</span>

                    </div>
                    <div className={`${styles.shareSelect} ${styles.anyrequstjoin}`}>
                      <Dropdown overlay={UserJoinMenu} placement="bottomRight" trigger={['click']}
                      overlayClassName='customdrpBox'
                      className="cusBoxDrp" >
                      <div className={`${styles.langSelSec} ${styles.every}`}>
                      <span>{getData.meetingDetail.authenticationJoin}</span>
                          
                        </div>
                      </Dropdown>
                    </div>
                </div>
              </div>
              <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
                <div className={styles.checkwaitingroom}>
                  <div className={styles.lftcheckconsec}>
                    <URCheckBox  onChange={(e: any) => meetingDetailStore('restrictScreenShare', e)}></URCheckBox>
                    <span className={styles.waitxtlft}  onClick={()=>updateMeetingDetail('restrictScreenShare',!getData.meetingDetail.restrictScreenShare)}>Only Host & Co-Host can share screen</span>
                  </div>
                </div>
              </div>
              <FileUpload_MeetingCreation files={fileOnchange} />


              {/* <div className={styles.formGroup}>
                <div className={styles.fileAttchconsec}>
                  <div className={styles.fileAttachList}>
                    <div className={styles.filesImage}><img src={iconxls} alt="filename" /></div>
                    <div className={styles.filesDetails} >
                      <span className={styles.fileName}>Audio_transcribe</span>
                      <span className={styles.fileDt}>4 MB Excel</span>
                    </div>
                    <div onClick={showModal}><span className={`icon_zoom2 ${styles.icnseachbg}`}></span></div>
                    <div className={styles.hoverClick}>
                      <Tooltip placement="top" title={'Remove File'}>
                        <span className="icon_close"></span>
                      </Tooltip>
                    </div>
                    <div className={styles.loadingIcon}>
                      <object data={file_loader} type="image/svg+xml">Loading...</object>
                    </div>
                  </div>
                  <div className={styles.fileAttachList}>
                    <div className={styles.filesImage}><img src={iconword} alt="filename" /></div>
                    <div className={styles.filesDetails}>
                      <span className={styles.fileName}>Audio_transcribe</span>
                      <span className={styles.fileDt}>4 MB Excel</span>
                    </div>
                    <div className={styles.hoverClick}>
                      <Tooltip placement="top" title={'Remove File'} overlayClassName="tooltipCenter">
                        <span className="icon_close"></span>
                      </Tooltip>
                    </div>
                  </div>
            
                </div>
                <div className={styles.attachfilecon}>
                  <div className={styles.attachconsec}>
                    <Upload>
                      <span className={`icon_Newdoc ${styles.plueiconcenter}`}></span>
                      <span className={styles.editUploadText}>Attached Document</span>
                    </Upload>
                  </div>
                </div>
              </div> */}

            </>
          }

          <div className={`${styles.formGroup} ${styles.marBtmmed}`}>
            <div className={styles.checkwaitingroom}>
              <div className={styles.lftcheckconsec}>
                <URCheckBox checked={getData.meetingDetail.save_template}
                 onChange={(e: any) => meetingDetailStore('save_template', e)}></URCheckBox>
                <span className={styles.waitxtlft} onClick={()=>updateMeetingDetail('save_template',!getData.meetingDetail.save_template)}>Save This As A Template</span>
                <div className={`${styles.footerBtn} ${styles.scheduleButton}`}>
                  <URButton className='urButton buttonWhite mr8' onClick={cancelMeeting} name="Cancel"></URButton>
                  <URButton className={`urButton buttonBlue ${getData.buttonEnableStatus ? 'disabled' : ''}`} onClick={editMeetingByUuid} name={currentWindowState=== "editMeeting" ? "Save" : currentWindowState=== "reschedule" ? "Reschedule" : "Schedule"}></URButton>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    {/*   <AddParticipant participantDetail={participantDetail} participantsInfo={getData.alternateHostDetails} /> */}
      <Modal title="Exit Schedule Meeting"
        centered
        visible={getData.isCancelMeetingModalVisible}
        onOk={cancelMeetingConfirm}
        onCancel={closeCancelMeetingModal}
        cancelText="No"
        okText="Yes"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
      Are you sure you want to exit without saving the changes you made to the Meeting Schedule?
      </Modal>
      {/* <Modal title="Object module.pdf"
        centered
        visible={isModalVisible}
        onCancel={cancelMeeting}
        className="DocumentcustomPopup">
        <div className="chatNoteImgContent">
          <img src={demo3} alt="" />
        </div>
      </Modal> */}
    </>
  );
};

